export enum Recurs {
  Day = "day",
  Week = "week",
  Month = "month",
}

export const recursLabels = {
  [Recurs.Day]: "Daily",
  [Recurs.Week]: "Weekly",
  [Recurs.Month]: "Monthly",
};
